<template>
  <v-app>
    <v-container class="pa-0">
      <v-row
        class="banner"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-responsive :aspect-ratio="1065/531">
            <v-img :src="service.image" class="rounded-b-xl"/>
          </v-responsive>
        </v-col>
      </v-row>
      <v-row
        class="mt-n16"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-card
            class="mx-10"
            rounded="xl"
            elevation="8"
            v-if="detail.status === 'BOOKED'"
          >
            <v-card-text
              class="text-center"
            >
              <div
                class="d-flex justify-center my-4"
              >
                <v-avatar size="100">
                  <v-img :src="brand.logo"/>
                </v-avatar>
              </div>
              <div
                class="mb-4 text-caption pink--text font-weight-bold"
              >成功預約</div>
              <div class="text-body-1 grey--text text--darken-4 font-weight-bold">
                {{ brand.name }} - {{ store.name }}
              </div>
              <div class="text-h6 grey--text text--darken-4 font-weight-bold">
                {{ service.name }}
              </div>
              <div class="text-body-1 mb-2">
                {{ detail.name }}・{{ formattedCell }}
              </div>
              <div class="text-body-2" v-if="detail.staff">
                服務人員 {{ detail.staff }}
              </div>
              <div class="text-body-2">
                {{ detail.date | moment('YYYY/M/D (ddd)') }} {{ detail.time }}・{{ detail.amount }} 位
              </div>
              <template v-if="detail.need_to_confirm">
                <div class="my-8 px-4 py-6 rounded-xl pink lighten-5 pink--text">
                  <div class="font-weight-bold">正在等待您的確認，請問您是否如期赴約？</div>
                  <div class="mt-4 my-2">
                    <v-btn
                      class="white--text"
                      color="pink"
                      rounded
                      depressed
                      large
                      v-on:click="confirmBook"
                    >
                      <v-icon left>mdi-check-all</v-icon>
                      我會赴約
                    </v-btn>
                  </div>
                  <div>
                    <v-btn
                      class="pink--text"
                      color="white"
                      rounded
                      depressed
                      v-on:click="showCancelModal = true"
                    >
                      <v-icon left>mdi-cancel</v-icon>
                      取消預約
                    </v-btn>
                  </div>
                </div>
              </template>
              <div
                class="d-flex justify-center my-4"
              >
                <v-btn
                  depressed
                  rounded
                  :href="`tel:${store.tel}`"
                  class="mr-2"
                >
                  <v-icon left>mdi-phone</v-icon>
                  撥打電話
                </v-btn>
                <v-btn
                  depressed
                  rounded
                  :href="`https://maps.google.com/?q=${store.address}`"
                  target="_blank"
                >
                  <v-icon left>mdi-map-marker</v-icon>
                  地圖
                </v-btn>
              </div>
              <div>
                <v-btn
                  rounded
                  depressed
                  v-on:click="showCancelModal = true"
                >
                  <v-icon left>mdi-cancel</v-icon>
                  取消此預約
                </v-btn>
              </div>
            </v-card-text>

            <v-card-text
              v-if="service.reminder"
            >
              <div
                class="mb-4 text-caption pink--text font-weight-bold"
              >{{ service.name }} 服務須知</div>
              <div
                class="mt-4 text-body-2 grey--text text--darken-1"
              >
                <vue-markdown :source="service.reminder" :options="{ linkify: true }"/>
              </div>
            </v-card-text>
          </v-card>

          <v-card
            class="mx-10"
            rounded="xl"
            elevation="8"
            v-if="detail.status === 'CANCELED_ONLINE'"
          >
            <v-card-text
              class="text-center"
            >
              <div
                class="d-flex justify-center my-4"
              >
                <v-avatar size="100">
                  <v-img :src="brand.logo"/>
                </v-avatar>
              </div>
              <div class="my-8 px-4 py-6 rounded-xl pink lighten-5 pink--text">
                <div class="font-weight-bold">
                  <v-icon color="pink" class="mr-2" small>mdi-alert</v-icon>
                  預約已經取消
                </div>
                <div class="mt-4 my-2">
                  <v-btn
                    class="white--text"
                    color="pink"
                    rounded
                    depressed
                    large
                    :to="`/${brand.id}/${store.id}`"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    再次預約
                  </v-btn>
                </div>
              </div>
              <div class="text-body-1 grey--text text--darken-4 font-weight-bold">
                {{ brand.name }} - {{ store.name }}
              </div>
              <div class="text-h6 grey--text text--darken-4 font-weight-bold">
                {{ service.name }}
              </div>
              <div class="text-body-1">
                {{ detail.name }}・{{ formattedCell }}
              </div>
              <div class="text-body-2">
                {{ detail.date | moment('YYYY/M/D (ddd)') }} {{ detail.time }}・{{ detail.amount }} 位
              </div>
              <div
                class="d-flex justify-center my-4"
              >
                <v-btn
                  depressed
                  rounded
                  :href="`tel:${store.tel}`"
                  class="mr-2"
                >
                  <v-icon left>mdi-phone</v-icon>
                  撥打電話
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <div class="my-4 text-center text-caption text--secondary">
            bookNow.tw ©️ All Rights Reserved.<br>
            <span v-if="brand.name">{{ brand.name }}</span>
            <span v-else>品牌</span>
            保留接受或拒絕預訂之權力
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="showCancelModal"
      width="500"
    >
      <v-card
        rounded="lg"
      >
        <v-card-title class="text-h6">是否要取消預約？</v-card-title>

        <v-form
          class="px-6"
          v-model="cancelValid"
          v-if="service.cancel_reason.length"
        >
          <v-container class="px-0">
            <v-row dense>
              <v-col>
                <v-select
                  :items="service.cancel_reason"
                  item-color="pink"
                  v-model="selectedCancelReason"
                  label="取消原因"
                  placeholder="請選擇"
                  color="pink"
                  hide-details
                  outlined
                  :rules="[value => !!value || '請選擇']"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-card-text>提醒您，取消後即無法還原</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="pink"
            text
            v-on:click="showCancelModal = false"
            rounded
          >
            保留預約
          </v-btn>
          <v-btn
            color="pink"
            text
            v-on:click="cancelBook"
            rounded
            :disabled="service.cancel_reason.length > 0 && !cancelValid"
          >
            取消預約
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Axios from '@/helpers/axios';
import VueMarkdown from 'vue-markdown-render';
import PhoneNumber from 'awesome-phonenumber';

export default {
  name: 'Booked',
  components: {
    VueMarkdown,
  },
  beforeMount() {
    const data = {
      token: this.$route.params.bookId,
    };

    Axios({
      method: 'POST',
      url: 'get',
      data,
    })
      .then((api) => {
        if (api.status === 200) {
          this.brand = api.data.brand;
          this.store = api.data.store;
          this.detail = api.data.detail;
          this.service = api.data.service;
        }
      });
  },
  data() {
    return {
      brand: {
        name: '',
        logo: '',
        image: '',
      },

      store: {
        token: '',
        name: '',
        image: '',
        address: '',
        tel: '',
      },

      detail: {
        amount: 0,
        date: '',
        time: '',
        name: '',
        contact: '',
        status: 'BOOKED',
      },

      service: {
        image: '',
        name: '',
        reminder: '',
        cancel_reason: [],
      },

      selectedCancelReason: null,
      cancelValid: false,
      showCancelModal: false,
    };
  },
  computed: {
    formattedCell() {
      if (this.detail.contact === '') return '';

      return new PhoneNumber(this.detail.contact, 'TW').getNumber('national');
    },
  },
  methods: {
    cancelBook() {
      const data = {
        token: this.$route.params.bookId,
      };

      if (this.selectedCancelReason) data.cancel_reason = this.selectedCancelReason;

      Axios({
        method: 'POST',
        url: 'cancel',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            window.location.reload();
          }
        });
    },
    confirmBook() {
      const data = {
        token: this.$route.params.bookId,
      };

      Axios({
        method: 'POST',
        url: 'confirm',
        data,
      })
        .then((api) => {
          if (api.status === 200) {
            window.location.reload();
          }
        });
    },
  },
  watch: {
    showCancelModal(val) {
      if (val === false) this.selectedCancelReason = null; this.cancelValid = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.banner
  position: sticky
  top: 0
</style>
